import { useDispatch } from "react-redux";
import { Form, Field } from "react-final-form";
import { Box, OutlinedInput, FormControl, FormHelperText, Typography } from "@material-ui/core";
import { authResetPasswordRequest } from "actions/authAction";
import { FC, useState } from "react";
import { STRONG_PASSWORD_REGEX } from "constants/constants";
import { OnChangeEvent } from "types/general";
import { useNav, useQuery } from "hooks/useNav";
import { useAuthFormStyles } from "../styles";
import { CustomButton } from "componentsNew/buttons/CustomButton";

interface ResetPasswordFormProps {}

export const ResetForm: FC<ResetPasswordFormProps> = () => {
  const classes = useAuthFormStyles();
  const { token } = useQuery().pageQueries;
  const { viewLogin } = useNav();
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [valid, setValid] = useState(false);

  const onSubmit = () => {
    dispatch(authResetPasswordRequest(newPassword, token, () => viewLogin()));
  };

  const validateNewPassword = (value: string) => {
    setNewPassword(value);
    if (STRONG_PASSWORD_REGEX.test(value)) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  return (
    <Box>
      <h2 className={classes.title}>New Password</h2>
      <Typography className={classes.description}>
        Password must be at least 8 characters, include lowercase and number.
      </Typography>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <>
            <FormControl component="fieldset" className={classes.formControl}>
              <Typography className={classes.label}>Password</Typography>
              <Field
                name="password"
                type="text"
                render={({ input, meta }) => (
                  <>
                    <OutlinedInput
                      {...input}
                      className={`${valid && classes.successColor}`}
                      value={newPassword}
                      onChange={(e: OnChangeEvent) => validateNewPassword(e.target.value)}
                      error={!valid}
                      required={true}
                    />
                    <FormHelperText className={classes.error}>
                      {meta.touched && meta.error}
                    </FormHelperText>
                  </>
                )}
              />
              <Typography className={classes.label}>Repeat Password</Typography>
              <Field
                name="repeat_password"
                type="text"
                render={({ input, meta }) => (
                  <>
                    <OutlinedInput
                      {...input}
                      className={`${valid && newPassword === repeatPassword && classes.successColor}`}
                      value={repeatPassword}
                      onChange={(e: OnChangeEvent) => setRepeatPassword(e.target.value)}
                      error={newPassword !== repeatPassword}
                      required={true}
                    />
                    <FormHelperText className={classes.error}>
                      {meta.touched && meta.error}
                    </FormHelperText>
                  </>
                )}
              />
            </FormControl>
            <CustomButton
              buttonText={"Submit"}
              
              onClick={handleSubmit}
              variant="contained"
              customClass={classes.authBtn}
              disabled={!valid || newPassword !== repeatPassword}
            />
          </>
        )}
      />
    </Box>
  );
};
